import { buildLocalPage } from "./_localPageBuilder";

export default buildLocalPage({
  slug: "tms-parkland-fl",
  cityName: "Parkland",
  county: "Broward County",
  distance: "10 minutes north",
  title: "TMS Treatment in Parkland, Florida",
  description:
    "TMS, SAINT®, and SPRAVATO® treatment for Parkland residents at our Coral Springs center. Serving Broward County. Schedule a consultation today.",
  keywords:
    "TMS Parkland FL, TMS therapy Parkland, SAINT Parkland, depression treatment Parkland Florida",
  localContext:
    "Parkland residents are among our closest neighbors — our Coral Springs center is roughly 10 minutes south via University Drive or Coral Ridge Drive. Because the drive is so short, many Parkland patients choose us for standard six-week TMS courses as well as the five-day accelerated SAINT® protocol. Parkland's residential, family-oriented community means we frequently work with adults balancing treatment around work and caregiving responsibilities, and we can schedule sessions to accommodate those demands.",
});
